export default __webpack_public_path__ + "static/banner_1_2-97eb71b43b826c395de02939f21e1ca9.jpg";